import React from "react";
import useCustomerButton from "@hooks/useCustomerButton";
import { Button } from "semantic-ui-react";

const CustomerButton = ({ name }) => {
  const { searchForCustomer } = useCustomerButton();

  return (
    <Button
      icon="user"
      compact
      onClick={(event) => searchForCustomer(event, name)}
    >
      {name}
    </Button>
  );
};

export default CustomerButton;
